/* istanbul ignore file */
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const WebhookConfigurationDisabledAsJSONParser = 
/* #__PURE__ */ parsers.object([
    ['tag', /* #__PURE__ */ parsers.exactly('disabled')],
]);
export class WebhookConfigurationDisabledAsJSON extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return WebhookConfigurationDisabledAsJSONParser.decode(input).map(res => new WebhookConfigurationDisabledAsJSON(res));
    }
    static unsafeDecode(input) {
        return WebhookConfigurationDisabledAsJSON.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return WebhookConfigurationDisabledAsJSONParser.encode(data);
    }
    static schema() {
        return WebhookConfigurationDisabledAsJSONParser.schema();
    }
}
